/* eslint-disable complexity */
/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import {connect} from 'react-redux';
import '../../TestView/styles.scss';

import getSingleChildTestResult from 'api/getSingleChildTestResult';
import updateLogEvent from 'api/updateLogEvent';
import strings from 'utils/strings';
import getQuestionChoices from '../Utils/getQuestionChoices';

import Subtest from '../SingleScreeningTest/Subtest';
import SubtestReport from '../SingleScreeningTest/SubtestReport';
import HandBook from '../SingleScreeningTest/HandBook';
import HorizontalBarChart from 'components/HorizontalBarChart';

import {withRouter} from 'react-router-dom';
import TestUserInfo from './TestUserInfo';

import {se} from './assets';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPrint} from '@fortawesome/free-solid-svg-icons';
import {getPronoun} from 'utils/getPronouns';
import AddNotesModal from '../../../components/AddNotesModal';

const TESTS_REQUIRED_TO_PASS = 3;
const NOT_AVAILABLE = strings.common.notavailable || 'Inte tillgänglig';
const HIDDEN_NAME = '<dolt namn>';

const get = (object, path, fallback) => {
	if (!object || !path) {
		return fallback;
	}

	const value = path.split('.').reduce((current, key) => {
		if (current && Object.prototype.hasOwnProperty.call(current, key)) {
			return current[key];
		}

		return undefined;
	}, object);

	return value === undefined || value === null ? fallback : value;
};

const hasValue = (value) => {
	return value !== undefined && value !== null && value !== '';
};

const asArray = (value) => {
	return Array.isArray(value) ? value : [];
};

const asObject = (value) => {
	return value && typeof value === 'object' && !Array.isArray(value)
		? value
		: {};
};

const asString = (value) => {
	return hasValue(value) ? String(value) : '';
};

const getCompleteName = (testUser) => {
	const firstName = get(testUser, 'firstName', '');
	const lastName = get(testUser, 'lastName', '');

	if (!firstName) {
		return HIDDEN_NAME;
	}

	return `${firstName} ${lastName || ''}`.trim();
};

const formatBirthDate = (birthdate) => {
	if (!birthdate) {
		return '';
	}

	const parsedBirthdate = moment(birthdate);

	if (!parsedBirthdate.isValid()) {
		return '';
	}

	return ` ${parsedBirthdate.format('DD.MM.YYYY')}`;
};

class SingleChildTest extends React.Component {
	constructor() {
		super();

		this.state = {
			showTestUserInfo: false,
			viewModes: {},
			testResult: null,
			testId: null,
			testType: null,
			isInKinderGarten: false,
			showResultsTab: false,
			showReportTab: true,
			showInformationTab: false,
			showHandBookTab: false,
			showResultsActive: 'tablink1',
			showReportActive: 'tablink2-active',
			showInformationActive: 'tablink3',
			showHandBookActive: 'tablink4',
			birthdate: null,
			showAddNotesModal: false,
			reportNotes: '',
			buttonTabs: [
				{
					id: 2,
					value: 'report',
					buttonClass: 'tablink2-active',
					text: strings.testView.rapport,
				},
				{
					id: 'defaultOpen',
					value: 'result',
					buttonClass: 'tablink1',
					text: strings.common.results,
				},

				{
					id: 3,
					value: 'info',
					buttonClass: 'tablink3',
					text: strings.candidates.userinformation,
				},
				{
					id: 4,
					value: 'book',
					buttonClass: 'tablink4',
					text: strings.common.handbok,
				},
			],
		};
	}

	componentDidMount() {
		const id = this.props.match.params.id;
		this.setState({
			testId: id,
		});
		window.scrollTo(0, 0);
		getSingleChildTestResult(id).then((testResult) => {
			const safeTestResult = testResult || {};
			let isInKinderGarten = false;
			const testUser = safeTestResult.testUser || {};
			const testInfo = safeTestResult.info || {};
			const birthDate = formatBirthDate(get(testUser, 'birthdate'));

			if (safeTestResult.type === 'child') {
				if (
					get(testInfo, 'class') == 0 ||
					get(testInfo, 'class') == 1 ||
					get(testInfo, 'class') == 2
				) {
					isInKinderGarten = true;
				}
			}

			asArray(safeTestResult.subtests).map((subtest) => {
				this.setViewMode(subtest.id, 'SHOW_ANSWERED');

				return subtest;
			});

			this.setState({
				testResult: safeTestResult,
				testType: safeTestResult.type,
				isInKinderGarten,
				birthDate,
			});
		});
	}
	getLanguageAssets = (language) => {
		switch (language) {
			case 'se':
			default:
				return se;
		}
	};

	/* 	getQuestionChoices(question) {
		const output = {};
		for (const choice of question.choices) {
			output[choice.letter] = choice;
		}
		return output;
	} */
	updatePrintLog(action) {
		updateLogEvent('print', this.state.testId, '', action);
	}
	//more robust log
	getAnswersWithCorrectAnswer(answers, answersCorrect, questions = false) {
		const output = [];
		const safeAnswers = asArray(answers);
		const safeAnswersCorrect = asArray(answersCorrect);
		const safeQuestions = asArray(questions);

		for (let i = 0; i < safeAnswers.length; i++) {
			let jInit = 0;

			if (
				safeAnswers[i] &&
				safeAnswersCorrect[i] &&
				safeAnswers[i].id === safeAnswersCorrect[i].id
			) {
				jInit = i;
			}

			if (!safeAnswers[i] || typeof safeAnswers[i].id === 'undefined') {
				break;
			}

			const currentAnswer = safeAnswers[i];
			const currentAnswerValue = asString(currentAnswer.value)
				.toLowerCase()
				.trim();

			for (let j = jInit; j < safeAnswersCorrect.length; j++) {
				const currentCorrectAnswer = safeAnswersCorrect[j];

				if (!currentCorrectAnswer) {
					continue;
				}

				if (currentAnswer.id === currentCorrectAnswer.id) {
					const correctAnswerValue = asString(
						currentCorrectAnswer.value
					)
						.toLowerCase()
						.trim();

					const isCorrectAnswer =
						currentAnswerValue === correctAnswerValue;

					const hasAltValues = Array.isArray(
						currentCorrectAnswer.altValues
					);

					const isCorrectAltValue =
						hasAltValues &&
						currentCorrectAnswer.altValues.indexOf(
							currentAnswerValue
						) !== -1;

					const answer = {
						id: currentAnswer.id,
						value: currentAnswerValue,
						isCorrect: isCorrectAnswer || isCorrectAltValue,
						correctValues: [correctAnswerValue],
					};

					if (hasAltValues) {
						answer.correctValues = [correctAnswerValue].concat(
							currentCorrectAnswer.altValues
						);
					}

					if (questions) {
						const question =
							safeQuestions[currentAnswer.id - 1] || {};
						answer.question = question.question || '';
						answer.choices = question.choices
							? getQuestionChoices(question)
							: {};
					}

					output.push(answer);
					break;
				}
			}
		}

		return output;
	}

	/* 	renderSubtestType0(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const correctClass = getCorrectClass(answer.isCorrect);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>{answers[index]}</span>
				</p>
			</div>
		);
	}
	renderSubtestType1(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const correctClass = getCorrectClass(answer.isCorrect);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>{answers[index]}</span>
				</p>
			</div>
		);
	}
	renderSubtestType2(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};
		const correctClass = getCorrectClass(
			answer.option === answers[index].correct
		);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>
						{answers[index].options[answer.option]}
					</span>
				</p>
			</div>
		);
	}

	renderSubtestType3(key, answer, index, answers) {
		//orddiktat
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const correctClass = getCorrectClass(
			answer.toLowerCase().trim() === answers[index].toLowerCase().trim()
		);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key - 1 + '. '}
					<span className={correctClass}>{answer}</span>
				</p>
			</div>
		);
	}
	renderSubtestType4(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${
				isCorrect === 2
					? 'correct'
					: isCorrect === 1
						? 'halfcorrect'
						: 'wrong'
			}`;
		};

		const correctClass = getCorrectClass(answer.isCorrect);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>{answers[index]}</span>
				</p>
			</div>
		);
	}
 */

	renderSubtestType0(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const correctClass = getCorrectClass(get(answer, 'isCorrect'));
		const safeAnswers = asArray(answers);

		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>
						{hasValue(safeAnswers[index])
							? safeAnswers[index]
							: NOT_AVAILABLE}
					</span>
				</p>
			</div>
		);
	}

	renderSubtestType1(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const correctClass = getCorrectClass(get(answer, 'isCorrect'));
		const safeAnswers = asArray(answers);

		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>
						{hasValue(safeAnswers[index])
							? safeAnswers[index]
							: NOT_AVAILABLE}
					</span>
				</p>
			</div>
		);
	}

	renderSubtestType2(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const safeAnswers = asArray(answers);
		const correct = get(safeAnswers[index], 'correct');
		const option = get(answer, 'option');
		const options = get(safeAnswers[index], 'options', {});
		const correctClass = getCorrectClass(option === correct);

		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>
						{hasValue(options[option])
							? options[option]
							: NOT_AVAILABLE}
					</span>
				</p>
			</div>
		);
	}

	renderSubtestType3(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const safeAnswers = asArray(answers);
		const answerValue = asString(answer);
		const correctAnswerValue = asString(safeAnswers[index]);

		const correctClass = getCorrectClass(
			answerValue.toLowerCase().trim() ===
				correctAnswerValue.toLowerCase().trim()
		);

		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key - 1 + '. '}
					<span className={correctClass}>
						{hasValue(answerValue) ? answerValue : NOT_AVAILABLE}
					</span>
				</p>
			</div>
		);
	}

	renderSubtestType4(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${
				isCorrect === 2
					? 'correct'
					: isCorrect === 1
						? 'halfcorrect'
						: 'wrong'
			}`;
		};

		const correctClass = getCorrectClass(get(answer, 'isCorrect'));
		const safeAnswers = asArray(answers);

		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>
						{hasValue(safeAnswers[index])
							? safeAnswers[index]
							: NOT_AVAILABLE}
					</span>
				</p>
			</div>
		);
	}
	renderSubtest(subtest) {
		return (
			<Subtest
				subtest={subtest}
				type="child"
				testType={this.state.testType} //is going to be used for better rendering of gjennomsnittig og stadaravvik skåre
				testResult={this.state.testResult} //is going to be used for rendering norms based on grade--agegroup
			>
				{this.renderAnswers(subtest)}
			</Subtest>
		);
	}
	renderSubtestReport(subtest, index) {
		return (
			<SubtestReport
				subtest={subtest}
				order={index + 1}
				type="child"
				testResult={this.state.testResult}
				testType={this.state.testType}
			/>
		);
	}

	toggleShowUnanswered(id) {
		if (this.state.viewModes[id] === 'SHOW_ALL') {
			this.setViewMode(id, 'SHOW_ANSWERED');
		} else {
			this.setViewMode(id, 'SHOW_ALL');
		}
	}

	setViewMode(id, value) {
		const obj = {};
		obj[id] = value;
		this.setState({
			viewModes: Object.assign({}, this.state.viewModes, obj),
		});
	}
	returnTestNameForId(id) {
		switch (id) {
			case 0:
				return strings.common.workingmemorytest;
			case 3:
				return strings.common.rapidautonamingtest;
			case 4:
				return strings.common.oneminutetest;
			case 5:
				return strings.common.spoonerismtest;
			case 6:
				return strings.common.letterknowledgetest;
			case 7:
				return strings.common.phonemisolationtest;
			case 8:
				return strings.common.phonemeomissiontest;
		}
	}
	/* renderAnswers(subtest) {
		const {answers} = subtest;
		const notAnswered = 0;
		let answersClass = '';
		const {viewModes} = this.state;
		let isVisible = true;
		switch (viewModes[subtest.id]) {
			case 'SHOW_ALL':
				answersClass = 'sub-test__answers--show-not-answered';
				break;
			case 'SHOW_ANSWERED':
				answersClass = '';
				break;
			case 'HIDE_ALL':
			default: {
				isVisible = false;
			}
		}

		switch (subtest.id) {
			case 0:
			case 1:
			case 2: {
				answersClass += ' col-2';
				break;
			}
			case 3:
			case 4:
			case 5:
			case 6:
			case 7:
			case 8: {
				answersClass += ' col-4';
				break;
			}
			case 9: {
				answersClass += ' col-3';
				break;
			}
			default:
				break;
		}

		const languageAssets = this.getLanguageAssets(subtest.language);
		const grade = this.state.testResult.info.class;
		const newAnswers = Object.entries(answers).map(
			([num, answer], index) => {
				const key = Number(num) + 1;
				switch (subtest.id) {
					case 0: {
						const correctAnswers = this.getLanguageAssets(
							subtest.language
						).test0;
						return Object.entries(answer).map(
							([num2, answer2], index2) => {
								const key2 = Number(num2) + 1;
								return this.renderSubtestType0(
									key2,
									answer2,
									index2,
									num === 'numbers'
										? correctAnswers.numbers
										: correctAnswers.words
								);
							}
						);
					}
					case 3: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							languageAssets.test3
						);
					}
					case 4: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							languageAssets.test4
						);
					}
					case 5: {
						return this.renderSubtestType4(
							key,
							answer,
							index,
							languageAssets.test5
						);
					}
					case 6: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							grade == 1 || grade == 0
								? languageAssets.testBH6
								: languageAssets.test6
						);
					}
					case 7: {
						return this.renderSubtestType2(
							key,
							answer,
							index,
							grade == 1 || grade == 0
								? languageAssets.testBH7
								: languageAssets.test7
						);
					}
					case 8: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							languageAssets.test8
						);
					}
					case 9: {
						return this.renderSubtestType3(
							key,
							answer,
							index,
							languageAssets.test9
						);
					}
					default:
						return '';
				}
			}
		);

		return (
			isVisible &&
			newAnswers.length && (
				<div>
					<h4 className="sub-test__answers__heading">
						{strings.testView.candidate_answers}
					</h4>
					<div className={`sub-test__answers ${answersClass}`}>
						{newAnswers}
					</div>
					{notAnswered > 0 && (
						<p className="sub-test__not-answered">
							<b>{`${notAnswered} ${strings.testView.oppgaverIkkeBesvart}`}</b>{' '}
							<button
								className="sub-test__link print-hide"
								onClick={(e) => {
									e.preventDefault();
									this.toggleShowUnanswered(subtest.id);
								}}
							>
								{viewModes[subtest.id] === 'SHOW_ALL'
									? 'Skjul ubesvarte'
									: 'Vis ubesvarte'}
							</button>
						</p>
					)}
				</div>
			)
		);
	} */

	renderAnswers(subtest) {
		const safeSubtest = subtest || {};
		const answers = asObject(safeSubtest.answers);
		const notAnswered = 0;
		let answersClass = '';
		const {viewModes} = this.state;
		let isVisible = true;

		switch (viewModes[safeSubtest.id]) {
			case 'SHOW_ALL':
				answersClass = 'sub-test__answers--show-not-answered';
				break;
			case 'SHOW_ANSWERED':
				answersClass = '';
				break;
			case 'HIDE_ALL':
			default: {
				isVisible = false;
			}
		}

		switch (safeSubtest.id) {
			case 0:
			case 1:
			case 2: {
				answersClass += ' col-2';
				break;
			}
			case 3:
			case 4:
			case 5:
			case 6:
			case 7:
			case 8: {
				answersClass += ' col-4';
				break;
			}
			case 9: {
				answersClass += ' col-3';
				break;
			}
			default:
				break;
		}

		const languageAssets = this.getLanguageAssets(safeSubtest.language);
		const grade = get(this.state.testResult, 'info.class');
		const newAnswers = Object.entries(answers).map(
			([num, answer], index) => {
				const key = Number(num) + 1;

				switch (safeSubtest.id) {
					case 0: {
						const correctAnswers = get(
							this.getLanguageAssets(safeSubtest.language),
							'test0',
							{}
						);

						return Object.entries(asObject(answer)).map(
							([num2, answer2], index2) => {
								const key2 = Number(num2) + 1;

								return this.renderSubtestType0(
									key2,
									answer2,
									index2,
									num === 'numbers'
										? correctAnswers.numbers
										: correctAnswers.words
								);
							}
						);
					}
					case 3: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							languageAssets.test3
						);
					}
					case 4: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							languageAssets.test4
						);
					}
					case 5: {
						return this.renderSubtestType4(
							key,
							answer,
							index,
							languageAssets.test5
						);
					}
					case 6: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							grade == 1 || grade == 0
								? languageAssets.testBH6
								: languageAssets.test6
						);
					}
					case 7: {
						return this.renderSubtestType2(
							key,
							answer,
							index,
							grade == 1 || grade == 0
								? languageAssets.testBH7
								: languageAssets.test7
						);
					}
					case 8: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							languageAssets.test8
						);
					}
					case 9: {
						return this.renderSubtestType3(
							key,
							answer,
							index,
							languageAssets.test9
						);
					}
					default:
						return '';
				}
			}
		);

		return (
			isVisible &&
			newAnswers.length > 0 && (
				<div>
					<h4 className="sub-test__answers__heading">
						{strings.testView.candidate_answers}
					</h4>
					<div className={`sub-test__answers ${answersClass}`}>
						{newAnswers}
					</div>
					{notAnswered > 0 && (
						<p className="sub-test__not-answered">
							<b>{`${notAnswered} ${strings.testView.oppgaverIkkeBesvart}`}</b>{' '}
							<button
								className="sub-test__link print-hide"
								onClick={(e) => {
									e.preventDefault();
									this.toggleShowUnanswered(safeSubtest.id);
								}}
							>
								{viewModes[safeSubtest.id] === 'SHOW_ALL'
									? 'Skjul ubesvarte'
									: 'Vis ubesvarte'}
							</button>
						</p>
					)}
				</div>
			)
		);
	}
	returnRelevantZscore(subTestsArray, testId) {
		const safeSubTestsArray = asArray(subTestsArray);

		for (let i = 0; i < safeSubTestsArray.length; i++) {
			if (safeSubTestsArray[i].id === testId) {
				return hasValue(safeSubTestsArray[i].zScore)
					? safeSubTestsArray[i].zScore
					: 0;
			}
		}

		return 0;
	}

	extractRatingDataForSubtest(subTestsArray, id) {
		const safeSubTestsArray = asArray(subTestsArray);

		for (let i = 0; i < safeSubTestsArray.length; i++) {
			if (safeSubTestsArray[i].id === id) {
				return hasValue(safeSubTestsArray[i].totalCorrect)
					? safeSubTestsArray[i].totalCorrect
					: 0;
			}
		}

		return 0;
	}
	assembleAsessment(
		scenario,
		lowScoredSubTests,
		writeUpText,
		completeName,
		subtestsToBeRendered,
		testUser
	) {
		switch (scenario) {
			case 'lowBH':
				if (
					lowScoredSubTests.length === 1 &&
					lowScoredSubTests[0] === strings.common.letterknowledgetest
				) {
					writeUpText.push(
						strings.formatString(
							strings.testView.assessmentBHonlyLK,
							`${completeName}`
						)
					);
					writeUpText.push(
						strings.formatString(
							strings.testView.assessmentokBHtest,
							`${completeName}`
						)
					);
				} else {
					for (let i = 0; i < lowScoredSubTests.length; i++) {
						switch (lowScoredSubTests[i]) {
							case strings.common.letterknowledgetest:
								writeUpText.push(
									strings.formatString(
										strings.testView.assessmentBHonlyLK,
										`${completeName}`
									)
								);
								break;

							case strings.common.workingmemorytest:
								writeUpText.push(
									strings.formatString(
										strings.testView.assessmentBHWM,
										`${completeName}`,
										`${this.returnRelevantZscore(
											subtestsToBeRendered,
											0
										)}`,
										`${completeName}`
									)
								);
								break;
							case strings.common.phonemisolationtest:
								writeUpText.push(
									strings.formatString(
										strings.testView.assessmentBHFI,
										completeName,
										this.returnRelevantZscore(
											subtestsToBeRendered,
											7
										)
									)
								);
								break;

							case strings.common.phonemeomissiontest:
								writeUpText.push(
									strings.formatString(
										strings.testView.assessmentBHFU,
										completeName,
										this.returnRelevantZscore(
											subtestsToBeRendered,
											8
										)
									)
								);
								break;

							case strings.common.rapidautonamingtest:
								writeUpText.push(
									strings.formatString(
										strings.testView.assessmentBHRI,
										completeName,
										this.returnRelevantZscore(
											subtestsToBeRendered,
											3
										)
									)
								);
								break;
							case strings.common.oneminutetest:
								const totalCorrect =
									this.extractRatingDataForSubtest(
										subtestsToBeRendered,
										4
									);
								let zScore;
								if (totalCorrect < 62) {
									zScore =
										` < ` +
										this.returnRelevantZscore(
											subtestsToBeRendered,
											4
										);
								} else if (totalCorrect > 61) {
									zScore =
										` > ` +
										this.returnRelevantZscore(
											subtestsToBeRendered,
											4
										);
								} else if (
									totalCorrect < 115 &&
									totalCorrect > 62
								) {
									zScore = this.returnRelevantZscore(
										subtestsToBeRendered,
										4
									);
								}
								writeUpText.push(
									strings.formatString(
										strings.testView.oneminutelowassesment,
										completeName,
										zScore || 0
									)
								);
								writeUpText.push(
									strings.testView.oneminutelowassesment2
								);
								break;
						}
					}
				}

				break;
			case 'lowFollowup':
				for (let i = 0; i < lowScoredSubTests.length; i++) {
					switch (lowScoredSubTests[i]) {
						case strings.common.workingmemorytest:
							writeUpText.push(
								strings.formatString(
									strings.testView.workingmemorylowassesment,
									`${completeName}`,
									`${this.returnRelevantZscore(
										subtestsToBeRendered,
										0
									)}`,
									`${getPronoun(get(testUser, 'gender'))}`
								)
							);
							break;
						case strings.common.rapidautonamingtest:
							writeUpText.push(
								strings.formatString(
									strings.testView.rapidnominationlowassesment,
									completeName,
									this.returnRelevantZscore(
										subtestsToBeRendered,
										3
									)
								)
							);
							break;
						case strings.common.oneminutetest:
							const zScore = this.returnRelevantZscore(
								subtestsToBeRendered,
								4
							);

							writeUpText.push(
								strings.formatString(
									strings.testView.oneminutelowassesment,
									completeName,
									zScore || 0
								)
							);
							writeUpText.push(strings.testView.oneminutelowassesment2);
							break;
						case strings.common.spoonerismtest:
							writeUpText.push(
								strings.formatString(
									strings.testView.spoonerismlowassesment,
									completeName,
									this.returnRelevantZscore(
										subtestsToBeRendered,
										5
									)
								)
							);
							break;
						case strings.common.phonemeomissiontest: // <-- matches returnTestNameForId(8)
							writeUpText.push(
								strings.formatString(
									strings.testView.fonemsubtraktionlowassesment, // add this string (see below)
									completeName,
									this.returnRelevantZscore(
										subtestsToBeRendered,
										8
									)
								)
							);
							break;
					}
				}
				break;
		}
	}
	returnTestUserGrade(testUser) {
		const safeTestUser = testUser || {};
		let testUserGrade = null;

		if (
			['child-followup', 'youth-followup'].includes(this.state.testType)
		) {
			const classValue = get(safeTestUser, 'class');

			testUserGrade = (
				<>
					<br />
					{hasValue(classValue)
						? `${classValue}.${strings.common.grade}`
						: `${strings.common.grade}: ${NOT_AVAILABLE}`}
					<br />
				</>
			);
		} else if (
			Object.prototype.hasOwnProperty.call(safeTestUser, 'class')
		) {
			const highestCompletedEducation = get(
				safeTestUser,
				'class',
				strings.common.notavailable || NOT_AVAILABLE
			);

			testUserGrade = (
				<>
					<br />
					{`${strings.candidates.education}: ${highestCompletedEducation}`}
					<br />
				</>
			);
		}

		return testUserGrade;
	}

	setRelevantTab(key, index) {
		const {buttonTabs} = this.state;
		for (let i = 0; i < buttonTabs.length; i++) {
			if (
				i === index &&
				!buttonTabs[index].buttonClass.includes('active')
			) {
				const counter = index + 1;
				buttonTabs[index].buttonClass = `tablink${counter}-active`;
			} else {
				const counter = i + 1;
				buttonTabs[i].buttonClass = `tablink${counter}`;
			}
		}
		switch (key) {
			case 'result':
				this.setState({
					showResultsTab: true,
					showReportTab: false,
					showInformationTab: false,
					showTestUserInfo: false,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'report':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: true,
					showTestUserInfo: false,
					showHandBookTab: false,

					showHandBookActive: 'tablink4',
					buttonTabs,
				});
				break;
			case 'info':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: false,
					showTestUserInfo: true,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'book':
				this.setState({
					showResultsTab: false,
					showReportTab: false,
					showInformationTab: false,
					showHandBookTab: true,
					showTestUserInfo: false,
					buttonTabs,
				});
				break;
		}
	}
	toggleAddNotesModal = () => {
		this.setState({showAddNotesModal: !this.state.showAddNotesModal});
	};
	// eslint-disable-next-line complexity
	render() {
		const {
			showTestUserInfo,
			testResult,
			testType,
			isInKinderGarten,
			birthDate,
			reportNotes,
		} = this.state;

		if (!testResult) {
			return null;
		}

		const testUser = testResult.testUser || {};
		const {
			currentUser: {
				firstName: adminFirstName = '',
				lastName: adminLastName = '',
			} = {},
		} = this.props;

		const adminCompleteName = `${adminFirstName} ${adminLastName}`.trim();
		const ownerFullName = testResult.adminFullName
			? testResult.adminFullName
			: '<Ikke tilgjengelig>';
		const isCommon = adminCompleteName === ownerFullName;
		const safeSubtests = asArray(testResult.subtests);
		const hasZero =
			safeSubtests.filter((subtest2) => subtest2.id === 0).length > 0;
		const subtestsToBeRendered = safeSubtests.filter((subtest) => {
			if ([1, 2].includes(subtest.id)) {
				return !hasZero;
			}

			return true;
		});
		const subtestsLength = subtestsToBeRendered.length;
		let zScoreLowCount = 0;
		const lowScoredSubTests = [];
		subtestsToBeRendered.forEach((subtest) => {
			if (Number(subtest.zScore) <= -1) {
				lowScoredSubTests.push(this.returnTestNameForId(subtest.id));
				zScoreLowCount++;
			}
		});
		const completeName = getCompleteName(testUser);
		const ageYears = get(testUser, 'age.years', NOT_AVAILABLE);
		const ageMonths = get(testUser, 'age.months', NOT_AVAILABLE);

		const writeUpText = [];
		if (isInKinderGarten) {
			if (!lowScoredSubTests.length) {
				writeUpText.push(
					strings.formatString(
						strings.testView.assessmentokBHtest,
						`${completeName}`
					)
				);
			} else if (lowScoredSubTests.length) {
				this.assembleAsessment(
					'lowBH',
					lowScoredSubTests,
					writeUpText,
					completeName,
					subtestsToBeRendered,
					testUser
				);
			}
		} else if (['child'].includes(testType) && !isInKinderGarten) {
			if (zScoreLowCount >= TESTS_REQUIRED_TO_PASS) {
				writeUpText.push(
					strings.formatString(
						strings.testView.asessmenttextnotok_1,
						`${completeName}`,
						`${zScoreLowCount}`,
						`${subtestsLength}`
					)
				);
			} else if (zScoreLowCount < TESTS_REQUIRED_TO_PASS) {
				writeUpText.push(
					strings.formatString(
						strings.testView.asessmenttextok_1,
						`${completeName}`,
						`${subtestsLength - zScoreLowCount}`
					)
				);
			}
		} else if (
			['child-followup', 'youth-followup', 'adult-followup'].includes(
				testType
			)
		) {
			if (!lowScoredSubTests.length) {
				writeUpText.push(
					strings.formatString(
						strings.testView.assesmenttextok_youthfollowup,
						`${completeName}`
					)
				);

				writeUpText.push(
					strings.formatString(
						strings.testView.assesmentok_recommendation_youthfollowup,
						completeName
					)
				);
			} else {
				this.assembleAsessment(
					'lowFollowup',
					lowScoredSubTests,
					writeUpText,
					completeName,
					subtestsToBeRendered,
					testUser
				);
			}
		}

		return (
			<div className="lit-single-test">
				<div>
					<div
						className={
							this.state.testType === 'child'
								? 'lit-single-youthtest-title-desc'
								: 'lit-single-adulttest-title-desc'
						}
					>
						<h1 className="lit-page-title">
							{this.state.showHandBookTab
								? strings.formatString(
										strings.testView.handbooktitle,
										<>
											<b>{strings.common.handbok}</b>
											<br />
											<br />
										</>
									)
								: this.state.showResultsTab
									? strings.formatString(
											strings.testView.dynamicheaderfortestresult_child,
											this.state.testType === 'child' ? (
												<>
													<br />
													<br />
													<b>
														{
															strings.testManagement.childfollowuptest
														}
													</b>
												</>
											) : this.state.testType ===
											  'youth-followup' ? (
												<>
													<b>
														<br />
														<br />
														{
															strings.testManagement.youthfollowuptest
														}
													</b>
												</>
											) : this.state.testType ===
											  'child-followup' ? (
												<b>
													<br />
													<br />
													{strings.testManagement.childfollowuptest}
												</b>
											) : (
												<>
													<br />
													<br />
													<b>
														{
															strings.testManagement.adultfollowuptest
														}
													</b>
												</>
											)
										)
									: this.state.showTestUserInfo
										? strings.formatString(
												strings.testView.dynamicheaderfortestcandidate_child,
												this.state.testType ===
													'child' ? (
													<>
														<br />
														<b>
															{strings.testManagement.childtest}
														</b>
													</>
												) : this.state.testType ===
												  'youth-followup' ? (
													<>
														<br />
														<br />
														<b>
															{
																strings.testManagement.youthfollowuptest
															}
														</b>
													</>
												) : this.state.testType ===
												  'child-followup' ? (
													<>
														<b>
															<br />
															<br />

															{
																strings.testManagement.childfollowuptest
															}
														</b>
													</>
												) : (
													<>
														<br />
														<br />
														<b>
															{
																strings.testManagement.adultfollowuptest
															}
														</b>
													</>
												)
											)
										: this.state.showReportTab
											? strings.formatString(
													strings.testView.dynamicheaderfortestreport_child,
													this.state.testType ===
														'child' ? (
														<b>
															{strings.testManagement.childtest}
														</b>
													) : this.state.testType ===
													  'youth-followup' ? (
														<>
															<br />
															<br />
															<b>
																{
																	strings.testManagement.youthfollowuptest
																}
															</b>
														</>
													) : this.state.testType ===
													  'child-followup' ? (
														<>
															<br />
															<br />
															<b>
																{
																	strings.testManagement.childfollowuptest
																}
															</b>
														</>
													) : (
														<>
															<br />
															<br />
															<b>
																{
																	strings.testManagement.adultfollowuptest
																}
															</b>
														</>
													)
												)
											: ''}
						</h1>
						<div>
							{!this.state.showHandBookTab &&
								this.state.showReportTab &&
								!this.state.showTestUserInfo && (
									<>
										<br />

										<span className="lit-printed-by">
											{strings.users.administrator + ': '}
										</span>
										<b style={{marginLeft: '4px'}}>
											{ownerFullName}
										</b>
										{!isCommon && (
											<>
												<span className="lit-printed-by">
													{strings.testView.lagretAv + ': '}
												</span>
												<b style={{marginLeft: '4px'}}>
													{adminCompleteName}
												</b>
											</>
										)}
									</>
								)}
						</div>
						{!this.state.showHandBookTab && (
							<p className="lit-page-lead">
								{strings.formatString(
									this.state.showResultsTab
										? strings.testView.newinfo_belowpresentsinformation
										: this.state.showTestUserInfo
											? strings.testView.newinfo3_belowpresentsinformation
											: this.state.showReportTab
												? strings.testView.newinfo2_belowpresentsinformation
												: '',

									<>
										<br />
										<br />
										<b>{completeName}</b>
										<br />{' '}
									</>,

									<span>
										<b>{birthDate}</b>
									</span>,
									<span>
										{this.returnTestUserGrade(testUser)}
									</span>
								)}
								{testResult.completedAt ? (
									strings.formatString(
										strings.testView.info_testwascompletedon,
										<>
											<b>
												{moment(
													testResult.completedAt
												).format('DD.MM.YYYY')}
												.
											</b>
											<br />
										</>
									)
								) : (
									<>
										<br />
										{
											strings.testView.info_testwasNotcompletedon
										}{' '}
										<br />
									</>
								)}
								{strings.formatString(
									strings.testView.infor_scr_ageAtCommencement,
									<b>{ageYears}</b>,

									<b>{ageMonths}</b>
								)}
							</p>
						)}
					</div>

					<div className="lit-tab-wrapper">
						<div className="lit-results-line" />
						{this.state.buttonTabs.map((tab, index) => {
							const id = tab.id;
							const value = tab.value;
							const buttonClass = tab.buttonClass;
							const btnText = tab.text;

							// eslint-disable-next-line react/jsx-key
							return (
								<button
									className={buttonClass}
									id={id}
									key={index}
									value={value}
									disabled={buttonClass.includes('active')}
									onClick={(e) => {
										this.setRelevantTab(
											e.target.value,
											index
										);
									}}
								>
									{btnText}
								</button>
							);
						})}
					</div>

					{this.state.showResultsTab &&
						!this.state.showHandBookTab &&
						!this.state.showReportTab &&
						!this.state.showInformationTab && (
							<div className="lit-histogram-Test_Details">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											window.print();
											this.updatePrintLog('Results');
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.testView.testresult
											)}
										</p>
									</button>
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.testView.incompleteMessage}
											</div>
										)}
										<h3 className="sub-test__name big">
											{strings.formatString(
												strings.testView.summary,
												strings.testView.testresult
											)}
										</h3>
										<div className="summary-chart">
											<HorizontalBarChart
												isChild
												subtests={subtestsToBeRendered}
											/>
										</div>
										<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														strings.testView.zscorered,
														<em>{strings.common.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{strings.testView.zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														strings.testView.zscoregreen,
														<em>{strings.common.over}</em>
													)}
												</p>
											</div>
										</div>
										{this.state.testType === 'child' &&
											!this.state.isInKinderGarten && (
												<div className="sub-test__scores">
													<div className="width--half center">
														<h4 className="sub-test__heading big">
															{strings.testView.assessment}
														</h4>

														{writeUpText.map(
															(text) => {
																return (
																	<p>
																		{text}
																	</p>
																);
															}
														)}
													</div>
												</div>
											)}
									</div>
									<div className="print-sub-tests">
										{subtestsToBeRendered.map((subtest) => {
											return this.renderSubtest(subtest);
										})}
									</div>
								</div>
							</div>
						)}
					{showTestUserInfo && (
						<TestUserInfo testResult={testResult} />
					)}
					{this.state.showReportTab &&
						!this.state.showHandBookTab &&
						!this.state.showTestUserInfo && (
							<div className="lit-histogram-Test_Report">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											this.updatePrintLog('Report');
											this.setState({reportNotes: ''});
											this.toggleAddNotesModal();
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.testView.testreport
											)}
										</p>
									</button>
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.testView.incompleteMessage}
											</div>
										)}
										<h3 className="sub-test__name big">
											{strings.formatString(
												strings.testView.summary,
												strings.testView.testreport
											)}
										</h3>

										<div className="summary-chart">
											<HorizontalBarChart
												isChild
												subtests={subtestsToBeRendered}
											/>
										</div>
										<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														strings.testView.zscorered,
														<em>{strings.common.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{strings.testView.zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														strings.testView.zscoregreen,
														<em>{strings.common.over}</em>
													)}
												</p>
											</div>
										</div>

										<div className="print-sub-tests-report">
											<h2
												className="sub-test-Report__name"
												style={{color: '#0f4256'}}
											>{strings.testView.uppfoljningensDeltest}</h2>{' '}
											{subtestsToBeRendered.map(
												(subtest, index) => {
													return this.renderSubtestReport(
														subtest,
														index
													);
												}
											)}
										</div>
										<br />
										<div>
											{(this.state.testType !== 'child' ||
												this.state
													.isInKinderGarten) && (
												<div className="sub-test__scores">
													<div className="width--half center">
														<h4 className="sub-test__heading big">
															{strings.testView.assessment}
														</h4>

														{writeUpText.map(
															(text) => {
																return (
																	<p>
																		{text}
																	</p>
																);
															}
														)}
														<p
															style={
																this.state
																	.testType ===
																'child-followup'
																	? {
																			whiteSpace:
																				'pre-line',
																		}
																	: undefined
															}
														>
															{this.state
																.testType ===
															'child-followup'
																? strings.testView.textUnderEveryChildFollowupAssessment
																: strings.testView.textUnderEveryFollowupAssessment}
														</p>
													</div>
												</div>
											)}
											<br />
											{reportNotes && (
												<>
													<div className="sub-test__comment-page-breaker" />
													<div className="sub-test__comment">
														<h4 className="sub-test__heading big">
															<span className="comment">
																{strings.testView.kommentarer}:
															</span>
															<p className="report-notes">
																{reportNotes}
															</p>
															<div className="line-one-text">
																{strings.testView.kommentarenSkrivenAv}{' '}
																{ownerFullName}
															</div>
															<div className="line-container">
																<div className="line line-1" />
															</div>
														</h4>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
							</div>
						)}
					{this.state.showHandBookTab && <HandBook />}
					{this.state.showAddNotesModal && (
						<AddNotesModal
							showModal={this.state.showAddNotesModal}
							toggleModal={this.toggleAddNotesModal}
							reportNotes={reportNotes}
							setReportNotes={(notes) => {
								this.setState({reportNotes: notes});
							}}
						/>
					)}
				</div>
			</div>
		);
	}
}

SingleChildTest.propTypes = {
	currentUser: PropTypes.shape({}),
};

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SingleChildTest)
);
